import React, { useState } from "react";
import "./ButtonGroup.css";
import WindowDimensions from "./WindowDimensions";

const ButtonGroup = ({ buttons, activeScope, changeDescriptorsOnClick }) => {
  const [clickedId, setClickedId] = useState(activeScope);
  const { width } = WindowDimensions();
  var isMobile = false;

  if (width <= 768) {
    isMobile = true;
  } else {
    isMobile = false;
  }

  const handleClick = (event, id) => {
    setClickedId(id);
    changeDescriptorsOnClick(event);
  };

  return (
    <div>
      {isMobile ? (
        <div style={{ display: "flex", width: "100%", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }}>
          {buttons.map((buttonLabel, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", flexWrap: "wrap", justifySelf: "space-evenly" }}>
              <button
                name={buttonLabel}
                onClick={(event) => handleClick(event, i)}
                className={i === clickedId ? "ButtonGroup-scope-button ButtonGroup-scope-button-active" : "ButtonGroup-scope-button"}
                style={{
                  width: "30vw",
                  height: "40px",
                  fontSize: "12pt",
                  borderRadius: "5px",
                  marginLeft: "10px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                {buttonLabel}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ display: "flex", width: "100%", flexDirection: "row", flexWrap: "nowrap" }}>
          {buttons.map((buttonLabel, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", flexWrap: "nowrap" }}>
              <button
                name={buttonLabel}
                onClick={(event) => handleClick(event, i)}
                className={i === clickedId ? "ButtonGroup-scope-button ButtonGroup-scope-button-active" : "ButtonGroup-scope-button"}
                style={{
                  width: "15vw",
                  height: "40px",
                  fontSize: "14pt",
                  borderRadius: "5px",
                  marginLeft: "20px",
                  marginRight: "20px",
                }}
              >
                {buttonLabel}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ButtonGroup;
